import authHeaders from 'helpers/auth-header';
import request from './api';

function updateMerch(id, body) {
  return request({
    url: `/merchant-info/id/${id}`,
    method: 'PUT',
    headers: authHeaders(),
    data: { ...body },
  });
}
function getMerchantType() {
  return request({
    url: `/definition/merchantTypes/all`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function getMerchant(identificationNumber) {
  return request({
    url: `/merchant/identification-number/${identificationNumber}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function deleteMerch(userId, merchantId) {
  return request({
    url: `/merchant-info/userId/${userId}/merchantId/${merchantId}`,
    method: 'DELETE',
    headers: authHeaders(),
  });
}

const merch = {
  updateMerch,
  getMerchant,
  getMerchantType,
  deleteMerch,
};

export default merch;
